"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var util_1 = require("@aperza/util");
exports.renderDate = function (value, props) {
    var _props = props ? props : exports.AcTimestamp.defaultProps;
    return exports.renderDateWithProps(__assign(__assign({}, _props), { value: value }));
};
exports.renderDateWithProps = function (props) {
    var value = props.value, emptyValue = props.emptyValue, needTimezoneConvert = props.needTimezoneConvert, timezoneId = props.timezoneId, format = props.format;
    if (!value)
        return emptyValue;
    var date = util_1.DateUtil.parse(value);
    if (!date)
        return emptyValue;
    if (needTimezoneConvert) {
        return util_1.DateUtil.formatUTC(date, timezoneId, format);
    }
    else {
        return util_1.DateUtil.formatUTC(date, 'UTC', format);
    }
};
/**
 * Display timestamp (date and time) in a specific timezone.
 *
 * If props are not defined, it will show an empty string.
 */
exports.AcTimestamp = function (props) {
    return react_1.default.createElement("span", { style: { whiteSpace: 'pre' } }, exports.renderDateWithProps(props));
};
exports.AcTimestamp.defaultProps = {
    needTimezoneConvert: true,
    timezoneId: 'Asia/Tokyo',
    format: 'YYYY-MM-DD HH:mm',
    emptyValue: '-',
};
exports.AcTimestamp.displayName = 'AcTimestamp';
//# sourceMappingURL=AcTimestamp.js.map